export const SHOW_TURNTABLE = 'SHOW_TURNTABLE_MAIN' //added MAIN page behind on 12/8/2022 because of share instant init
export const SET_TURNTABLE_SIZE = 'SET_TURNTABLE_SIZE'
export const SET_RESULT_SELECTED = 'SET_RESULT_SELECTED'
export const SET_CHOICES = 'SET_CHOICES_MAIN'
export const CHANGE_KEY_TEXT = 'CHANGE_KEY_TEXT_MAIN'
export const SET_MODE = 'SET_MODE'
export const LOAD_DONOR_BOX = 'LOAD_DONOR_BOX'
export const SAVE_LOCAL_CHOICES_LIST = 'SAVE_LOCAL_CHOICES_LIST'
export const SET_SAVED_LISTS = 'SET_SAVED_LISTS'
export const SET_HISTORY = 'SET_HISTORY_MAIN'
export const SET_TITLE_OBJ = 'SET_TITLE_OBJ_MAIN'
export const SET_WEIGHT_ON = 'SET_WEIGHT_ON'
export const INSTANT_INIT = 'INSTANT_INIT_MAIN'
export const RESET_INITIAL_STATE = 'RESET_INITIAL_STATE_MAIN'
export const REPLACE_STATE = 'REPLACE_STATE_MAIN'
export const SET_HEADLINE_ON = 'SET_HEADLINE_ON'
export const SET_COLOR_ON = 'SET_COLOR_ON'
export const SET_INPUT_SHOW_MODE = 'SET_INPUT_SHOW_MODE'
export const SET_INPUT_EDIT_MODE = 'SET_INPUT_EDIT_MODE'
export const SET_MYSTERY_WHEEL_ON = 'SET_MYSTERY_WHEEL_ON_MAIN'
export const SET_MYSTERY_RESULT_ON = 'SET_MYSTERY_RESULT_ON_MAIN'
export const UPDATE_MYSTERY_SETTINGS = 'UPDATE_MYSTERY_SETTINGS_MAIN'
export const SET_SCORES = 'SET_SCORES_MAIN'
export const SET_AUTO_ADD_COUNT = 'SET_AUTO_ADD_COUNT_MAIN'
export const SET_CHOICE_HD_IMAGES = 'SET_CHOICE_HD_IMAGES_MAIN'
export const SET_AI_INPUT_LOGIN = 'SET_AI_INPUT_LOGIN_MAIN'
export const SET_AI_INPUT_OPENED = 'SET_AI_INPUT_OPENED_MAIN'
export const SET_AI_INPUT_GROUPS = 'SET_AI_INPUT_GROUPS_MAIN'
